<div class="connect-background">
    <div>
        <div class="width-100 connect-home-header">
            <div class="col-12 main-block">
                <div class="row">
                    <div class="row col-5">
                        <img src="assets/img/UnityC_RGB_app_72ppi.jpg" class="img-fluid cursor-pointer unityc-logo" alt="UnityC Logo" [routerLink]="['/home']">
                    </div>
                    <div class="row col-7">
                        <div class="col-12 padding-right-0 padding-left-0">
                            <div class="float-right">

                                <button mat-icon-button class="width-auto" [matMenuTriggerFor]="userMenu" aria-label="more menu options">
                                    <i><img class="margin-right-5 profile-img" src="assets/img/profile.png"  /></i>
                                    <span class="margin-right-5">{{user?.fullName}}</span>
                                    <span><i class="fa fa-chevron-down"></i></span>
                                </button>
                                <mat-menu #userMenu="matMenu">
                                    <button mat-menu-item (click)="goToMyCredentials()">
                                        <mat-icon>settings</mat-icon>
                                        <span>My Credentials</span>
                                    </button>
                                    <button mat-menu-item (click)="goToMyFiles()">
                                        <mat-icon>settings</mat-icon>
                                        <span>My Files</span>
                                    </button>
                                    <button mat-menu-item [routerLink]="['/login']">
                                        <mat-icon>exit_to_app</mat-icon>
                                        <span>Logout</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>
                        <div class="col-12 padding-right-0 padding-left-0" >
                            <div *ngIf="user?.hasAnyRealEstateAgentNotification" class="float-right">
                                <mat-slide-toggle
                                        name="notificationPreference1"
                                        [title]="getOptOptionTitle()"
                                        [(ngModel)]="isNotificationOptedIn"
                                        (change)="toggleOptOut($event)" >
                                    Receive Notifications
                                </mat-slide-toggle>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>
        <div class="col-12 main-block main-content margin-top-in-print">


<!--            <xng-breadcrumb>-->
<!--                <ng-container *xngBreadcrumbItem="let breadcrumb;let first = first;let last = last;">-->
<!--                    <mat-icon *ngIf="!first"-->
<!--                              class="mat-icon notranslate material-icons mat-icon-no-color font-white" role="img"-->
<!--                              aria-hidden="true">keyboard_arrow_right-->
<!--                    </mat-icon>-->
<!--                    <span *ngIf="!first">{{ breadcrumb}}</span>-->
<!--                    <span *ngIf="first && !last" class="margin-left-15"><i class="fa fa-home font-15" aria-label="Home"></i></span>-->
<!--                </ng-container>-->
<!--            </xng-breadcrumb>-->

            <div class="height-100 padding-top-10 padding-bottom-10">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</div>

<!--<div class="footer-block d-none d-lg-block justify-content-lg-center ">-->
<!--    <dp-footer></dp-footer>-->
<!--</div>-->

